export class CustomerAccountsRequest {
    accountCodes: string[];
    constructor(accountCodes?: string[]) {
        this.accountCodes = accountCodes ?? [];
    }
}
